<template>
    <div>
        <span class="fw-bold">{{ $t('transport_log.modal.'+ title) }}</span>: <span class="fs-6">{{ value }}</span>
    </div>
</template>

<script>
export default {
    name: "PreviewField",
    props: {
        title: String,
        value: String
    }
}
</script>

<style scoped>

</style>
